import Link from 'next/link'
import { join, sum } from 'shared/utils/array'
import format from 'date-fns/format'
import { makePage } from '@/components/page'
import { useVenueContext } from '@/services/venue'
import { usePrice } from '@/components/price'
import { useAppContext } from '@/pages/_app'
import { HeadPanel } from '@/components/head-panel'

export default makePage(
  {
    clientRenderOnly: {},
    meta: {
      subTitle: 'orders:myOrders',
      noIndex: true,
    },
  },
  function OrdersPage() {
    const { t } = useAppContext()
    const venueContext = useVenueContext()!
    const { venue, venueName, menuRoute, orderManager, locale } = venueContext
    const { orderHistory } = orderManager
    const price = usePrice()

    if (!venueName || !venue) {
      return null
    }

    return (
      <div>
        <HeadPanel url={menuRoute.path} text={t('orders:myOrders')} />
        {orderHistory.size > 0 ? (
          <div>
            {join(
              Array.from(orderHistory.entries())
                .filter(([, entry]) => {
                  return entry.serverOrder && entry.serverOrder.status.type === 'numberReady'
                })
                .sort((a, b) => {
                  return b[1].timestamp - a[1].timestamp
                })
                .map(([key, entry]) => {
                  return (
                    <Link
                      key={key.clientUuid}
                      href={`/venue/${venueName}/order/${key.clientUuid}`}
                      legacyBehavior
                    >
                      <div className="px-5 py-3 cursor-pointer">
                        <div className="font-medium text-lg mb-2">
                          {format(entry.timestamp, 'd MMMM yyyy HH:mm', { locale })}
                        </div>
                        <div className="flex justify-between">
                          <div>
                            {entry.serverOrder?.status.type === 'numberReady'
                              ? `${t('common:anOrder')} №${entry.serverOrder.status.number}`
                              : `${t('common:anOrder')} (${entry.orderedProducts.length} ${t(
                                  'orders:itms',
                                )})`}
                          </div>
                          <div>
                            {price.format(
                              entry.serverOrder?.prices.total ||
                                sum(
                                  entry.orderedProducts.map((product) => {
                                    return Number(product.price) * Number(product.quantity)
                                  }),
                                ),
                            )}
                          </div>
                        </div>
                      </div>
                    </Link>
                  )
                }),
              <div className="mx-5 border-b-2 border-ghost dark:border-ghostDark"></div>,
            )}
          </div>
        ) : (
          <div className="px-5 py-4">{t('orders:listIsEmpty')}</div>
        )}
      </div>
    )
  },
)

export {
  getVenueStaticPaths as getStaticPaths,
  getVenueStaticProps as getStaticProps,
} from '@/services/venue'
